module.exports = __webpack_public_path__ + "img/tk_zasedeno.1660c2f1.svg";